




























































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* components */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Toast from '@/app/components/Common/Toast.vue'
import FieldGraph from '@/app/components/FieldDetails/Graph/FieldGraph.vue'
import DetailsContent from '@/app/components/FieldDetails/Details/DetailsContent.vue'
import GraphSettingModal from '@/app/components/FieldDetails/Graph/GraphSettingModal.vue'
/* api */
import graphDataApi from '@/app/model/api/graphDataApi'
import GraphImageModal from '@/app/components/FieldDetails/Graph/GraphImageModal.vue'
import GraphMainImageModal from '@/app/components/FieldDetails/Graph/GraphMainImageModal.vue'
import FieldSensorApi from '@/app/model/api/fieldSensorApi'
/* module */
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import Session from '@/app/module/session'
import { routerPath } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    Toast,
    FieldGraph,
    DetailsContent,
    GraphImageModal,
    GraphMainImageModal,
    GraphSettingModal
  }
})
export default class FieldDetails extends Vue {
  private showGraphSettingModal:boolean = false
  private harvestDays: number = 0
  private graphData: {[key: string]: any} = {
    estimated_yield: {
      date: 0,
      harvest_date_latest: 0,
      harvest_date_earliest: 0,
      harvest_date_goal: 0,
      harvest_date_earliest_goal: 0,
      harvest_date_latest_goal: 0,
      test_harvest_date_earliest: null,
      test_harvest_date_latest: null
    },
    graph: {},
    harvest_status: 0,
    harvest_status_update_date: ''
  }
  private masterData: {[key: string]: any} = {
    estimated_yield: {
      date: 0,
      harvest_date_latest: 0,
      harvest_date_earliest: 0,
      harvest_date_goal: 0,
      harvest_date_earliest_goal: 0,
      harvest_date_latest_goal: 0,
      test_harvest_date_earliest: null,
      test_harvest_date_latest: null
    },
    graph: {},
    growth_stage: [],
    planting_date: 0
  }
  private comparisonData: {[key: string]: any} = {
    estimated_yield: {
      date: 0,
      harvest_date_latest: 0,
      harvest_date_earliest: 0,
      harvest_date_goal: 0,
      harvest_date_earliest_goal: 0,
      harvest_date_latest_goal: 0,
      test_harvest_date_earliest: null,
      test_harvest_date_latest: null
    },
    graph: {},
    growth_stage: [],
    planting_date: 0
  }
  /* 凡例 */
  private showGrowthHeight = true
  private showImtegrationTemperature = true
  private showSoilMoisture = false
  private showSpad = false
  private showStemNumber = false
  private showGraphLoading: boolean = true
  private showTargetValue: boolean = true
  private showErrorAlert: boolean = false
  private showPlantingModal: boolean = false
  private showComparison: boolean = false
  private toastMessage: string = ''
  private renderGraph: boolean = false
  /* グラフ表示項目 */
  private displayYearSeason: string = ''
  private displayGraphDefault: string = '積算温度/草丈/幼穂長'
  private displayGraphMaster: string = 'なし'
  private displayGraphComparison: string = 'なし'
  private showGraphImageModal: boolean = false
  private showGraphMainImageModal: boolean = false

  /* computed */
  private get growthHeight (): number {
    return this.$store.state.graphToggleState.toggleGrowthHeight
  }
  private get soilMoisture (): number {
    return this.$store.state.graphToggleState.toggleSoilMoisture
  }
  private get comparisonGraph (): number {
    return this.$store.state.graphToggleState.showComparison
  }
  private get displayYear (): number {
    return this.$store.state.fieldDetailsState.displayYear
  }
  private get agrinoteImg (): boolean {
    return this.$store.state.setFlagState.agrinoteImgFlag
  }
  private get agrinoteMainImg (): boolean {
    return this.$store.state.setFlagState.agrinoteMainImgFlag
  }

  @Watch('growthHeight')
  changeGrowthHeight (flag: boolean) {
    this.showGrowthHeight = flag
  }
  @Watch('soilMoisture')
  changeSoilMoisture (flag: boolean) {
    this.showSoilMoisture = flag
  }
  @Watch('comparisonGraph')
  changeComparison (flag: boolean) {
    this.showComparison = flag
  }
  @Watch('displayYear')
  changeDisplayYaer (year: string) {
    this.displayYearSeason = year
  }
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange (newVal: any) {
    /* flagリセット */
    this.$store.commit('setFlagState/setGraphDialogFlag', false)
  }
  @Watch('agrinoteImg')
  changeagrinoteImg (flag: boolean) {
    this.showGraphImageModal = flag
  }
  @Watch('agrinoteMainImg')
  changeagrinoteMainImg (flag: boolean) {
    this.showGraphMainImageModal = flag
  }

  created () {
    /* セッションストレージ削除 */
    sessionStorage.removeItem('testData')
    sessionStorage.removeItem('testEarliestHarvestDay')
    sessionStorage.removeItem('testLatestHarvestDay')

    const id = this.$route.params.field_id
    let flag = true

    this.getMasterData(id, 'master', flag)
    this.getGraphData(id, 'plant', flag)

    this.$store.commit('routeState/setRoute', this.$route.path)
  }

  /*
   * 画面遷移時にグラフデータを初期化
   */
  destroyed () {
    /* ローカルストレージ削除 */
    localStorage.removeItem('earliestHarvestDay')
    localStorage.removeItem('latestHarvestDay')
    localStorage.removeItem('growthStage')
    localStorage.removeItem('predictionData')
    localStorage.removeItem('masterData')
    localStorage.removeItem('defaultGraph')
    localStorage.removeItem('graphData')
    localStorage.removeItem('comparisonData')

    /* フラグリセット */
    this.$store.commit('setFlagState/setGraphDialogFlag', false)
    this.$store.commit('graphToggleState/setHiddenComparisonData', true)
    this.$store.commit('graphState/setDefaultGraphYear', '')
    this.$store.commit('graphState/setDefaultGraphSeason', '')
  }

  private showModal () {
    this.showGraphSettingModal = true
  }

  private closeModal () {
    this.showGraphSettingModal = false
  }

  /* 比較データを追加 */
  private addComparisonData (val: any) {
    (async () => {
      const result = await graphDataApi.getGraphData(val.id, val.type, false)

      if (result.isOk()) {
        // 元々入っているデータと取得したデータが同じ場合は何もしない
        if (JSON.stringify(result.getPayload()) === JSON.stringify(this.comparisonData)) {
          return
        }
        this.comparisonData = result.getPayload()
        Session.setComparisonData(JSON.stringify(this.comparisonData.graph)!)
        Session.setComparisonYoungData(JSON.stringify(this.comparisonData.young_graph_actual)!)
        this.$store.commit('setFlagState/setComparisonPlantFlag', true)
        this.showTargetValue = true
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.toastMessage = result.getPayload().message
        this.showErrorAlert = true
      }
    })()
  }

  /* 比較のマスターデータを取得 */
  private getComparisonMaster (val: any) {
    (async () => {
      const result = await graphDataApi.getGraphData(val.id, val.type, false)
      if (result.isOk()) {
        Session.setComparisonStageData(JSON.stringify(result.getPayload().growth_stage))
        Session.setComparisonPredictionData(JSON.stringify(result.getPayload().graph)!)
        this.$store.commit('setFlagState/setComparisonMasterFlag', true)
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.toastMessage = result.getPayload().message
        this.showErrorAlert = true
      }
    })()
  }

  /* 実測データ取得 */
  private getGraphData (id: string, type: string, flag: boolean) {
    (async () => {
      const result = await graphDataApi.getGraphData(id, type, flag)

      if (result.isOk()) {
        this.graphData = result.getPayload()

        Session.setPlantingId(this.graphData.planting_id)
        Session.setEstimatedDate(this.graphData.estimated_yield.date)
        Session.setAgrinoteRecods(JSON.stringify(this.graphData.agrinote_recods)!)
        this.$store.commit('setFlagState/setPlantingIdFlag', true)

        if (this.graphData.planting_id === 0) {
          const children: any = this.$refs.updateGraphData

          this.toastMessage = '作付け情報がありません。'
          this.showPlantingModal = true

          if (children !== null && children !== undefined) {
            children.hiddenGraphItem()
          }
        } else if (this.graphData.planting_id !== 0 && (this.graphData.graph === null || this.graphData.graph_goal === null)) {
          const children: any = this.$refs.updateGraphData

          this.toastMessage = '作付け予測データが作成されていません。'
          this.showPlantingModal = true

          if (children !== null && children !== undefined) {
            children.hiddenGraphItem()
          }
        } else {
          Session.setHarvestStatus(String(this.graphData.harvest_status))
          Session.setHarvestStatusDay(this.graphData.harvest_status_update_date)
          Session.setGraphLastDay(Object.keys(result.getPayload().graph).pop())
          Session.setGraphData(JSON.stringify(this.graphData.graph)!)
          Session.setDefaultGraphData(JSON.stringify(this.graphData.graph)!)
          Session.setYoungData(JSON.stringify(this.graphData.young_graph_actual)!)

          /* 現在表示しているグラフの年とシーズンを保持 */
          if (this.$store.state.graphState.defaultGraphYear === '') {
            this.$store.commit('graphState/setDefaultGraphYear', this.graphData.year)
            this.$store.commit('graphState/setDefaultGraphSeason', this.graphData.season)
          }

          this.renderGraph = true

          // localStorage変更フラグ更新
          this.$store.commit('setFlagState/setGraphDialogFlag', true)
          this.$store.commit('setFlagState/setSensorDataFlag', true)

          // センサーデータ取得
          this.getSensorData()

          /* 表示年度変更 */
          let fieldGraph:any = this.$refs.fieldGraph
          if (fieldGraph !== undefined) {
            fieldGraph.updateDisplayYear()
          }

          // flag
          this.$store.commit('setFlagState/setGraphChangeDisplayYear', true)
        }
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.toastMessage = result.getPayload().message
        this.showErrorAlert = true
      }
    })()
  }

  /* センサーデータ取得 */
  private getSensorData () {
    (async () => {
      // localStorageにセンサーデータがなければAPIを叩く
      const result = await FieldSensorApi.getSensorData(this.graphData.planting_id, 'all')
      let sensorList = []

      if (result.isOk()) {
        // 取得で来たらタイムスタンプを付与してlocalStorageに追加
        sensorList = result.getPayload()
        sensorList.unshift({ timestamp: Date.now() })
        Session.setSensorData(JSON.stringify(sensorList), this.graphData.planting_id)
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.toastMessage = result.getPayload().message
        this.showErrorAlert = true
      }

      // localstorageフラグ更新
      this.$store.commit('setFlagState/setSensorDataFlag', true)
    })()
  }

  /* 表示年変更 */
  private changeDisplayYear (id: string) : void {
    this.getGraphData(id, 'plant', false)
    this.getMasterData(id, 'master', false)
  }

  /* マスターデータ取得 */
  private getMasterData (id: string, type:string, flag: boolean) {
    (async () => {
      const result = await graphDataApi.getGraphData(id, type, flag)

      if (result.isOk()) {
        Session.setVarietyId(result.getPayload().variety_id)
        if (result.getPayload().growth_stage.length !== 0) {
          this.masterData = result.getPayload()
          this.$store.commit('stageUpdateState/setChangeId', 0)

          Session.setPlantingDay(JSON.stringify(this.masterData.planting_date))

          Session.setEarliestHarvestDay(JSON.stringify(this.masterData.estimated_yield.harvest_date_earliest))
          Session.setLatestHarvestDay(JSON.stringify(this.masterData.estimated_yield.harvest_date_latest))
          Session.setGoalEarliestHarvestDay(JSON.stringify(this.masterData.estimated_yield.harvest_date_earliest_goal))
          Session.setGoalLatestHarvestDay(JSON.stringify(this.masterData.estimated_yield.harvest_date_latest_goal))

          Session.setGrowthStage(JSON.stringify(this.masterData.growth_stage)!)
          Session.setPredictionData(JSON.stringify(this.masterData.graph)!)
          Session.setMasterData(JSON.stringify(this.masterData.graph_goal)!)
          Session.setYoungGoalData(JSON.stringify(this.masterData.young_graph_goal)!)

          /* 検証グラフ 有効の場合のみsession作成 */
          if (this.masterData.test_graph !== null) {
            Session.setTestData(JSON.stringify(this.masterData.test_graph)!)
          }

          /* 検証収穫適期幅 共通でsession作成 */
          Session.setTestEarliestHarvestDay(JSON.stringify(this.masterData.estimated_yield.test_harvest_date_earliest))
          Session.setTestLatestHarvestDay(JSON.stringify(this.masterData.estimated_yield.test_harvest_date_latest))

          /* データ追加フラグ */
          this.$store.commit('setFlagState/setGraphMasterDataFlag', true)

          /* 表示年度とシーズン */
          let year = this.masterData.year
          let display = year + '年 ' + this.masterData.season
          this.$store.commit('fieldDetailsState/setDisplayYear', display)
          this.displayYearSeason = display
          /* 表示目標 */
          // 目標値データがない場合は「なし」ある場合は目標名を表示する
          if (this.masterData.graph_goal === null || this.masterData.graph_goal === undefined) {
            this.displayGraphMaster = 'なし'
          } else {
            this.displayGraphMaster = this.masterData.graph_goal_name
          }

          this.$store.commit('stageUpdateState/setDefaultStageData', this.masterData.growth_stage)

          this.showGraphLoading = false
          this.harvestDays = this.getHarvestDays()
        } else {
          Session.setMasterData('{}')
          this.showGraphLoading = false
        }
      } else if (result.checkTimeoutErrorStatus()) {
        this.$store.commit('routeState/setTimeoutErrorFlag', true)
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkErrorStatus()) {
        this.$store.commit('routeState/setErrorFlag', true)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkNotFoundStatus()) {
        this.$store.commit('routeState/setErrorFlag', false)
        this.$router.push(routerPath.PATH_ERROR_PAGE)
      } else if (result.checkStatus()) {
        CommonClass.doLogout()
      } else {
        this.toastMessage = result.getPayload().message
        this.showErrorAlert = true
      }
    })()
  }

  private reacquireStageData () {
    this.getMasterData(this.graphData.planting_id, 'master', false)
    this.getGraphData(this.graphData.planting_id, 'plant', false)
  }

  private toDate (val: number) : string {
    return DateClass.displayData(val)
  }

  /* マスタデータ表示切り替え */
  public displayMasterGraph (flag: boolean) {
    const children: any = this.$refs.updateGraphData
    children.displayMasterGraph(flag)
  }

  /* 収穫適期までの日数を計算 */
  private getHarvestDays () {
    let harvestDate = this.masterData.estimated_yield.date
    let today = '' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate())

    if (today >= harvestDate) {
      return 0
    }

    return DateClass.daysCalculation(parseInt(today), harvestDate)
  }

  /* グラフ表示項目を表示 */
  private displayGraphItem (val: any) {
    /* 項目 */
    let itemList = []
    let displayText: string = ''
    for (var i in val.checkbox) {
      itemList.push(val.checkbox[i].label)
    }

    for (var j in itemList) {
      displayText += itemList[j] + '/'
    }

    /* 最後に/がついている場合は削除 */
    if (displayText.slice(-1) === '/') {
      displayText = displayText.slice(0, -1)
    }

    this.displayGraphDefault = displayText

    /* 目標 */
    if (this.masterData === null || this.masterData === undefined) {
      this.displayGraphMaster = 'なし'
    } else {
      this.displayGraphMaster = this.masterData.graph_goal_name
    }

    /* 比較(圃場) */
    if (val.field !== '') {
      this.displayGraphComparison = val.field
    } else if (val.past !== '') {
      this.displayGraphComparison = val.past
    } else {
      this.displayGraphComparison = 'なし'
    }
  }

  /* 表示するグラフを変更 */
  public changeCheckboxes (data: any) {
    let fieldGraph:any = this.$refs.fieldGraph
    fieldGraph.displayGraph(data)
  }

  private closePlantingModal () {
    this.showPlantingModal = false
  }

  private showSeasonError () {
    this.toastMessage = '作付け情報が見つかりませんでした。'
    this.showErrorAlert = true
  }

  private closeAlert () {
    this.showErrorAlert = false
  }

  public closeGraphImageModal () {
    this.showGraphImageModal = false
    this.$store.commit('fieldDetailsState/setAgrinoteImgDate', 0)
  }

  public showErrorToast (msg: string) {
    this.showGraphSettingModal = false
    this.toastMessage = msg
    this.showErrorAlert = true
  }

  public closeGraphMainImageModal () {
    this.showGraphMainImageModal = false
    this.$store.commit('fieldDetailsState/setAgrinoteImgDate', 0)
  }
}
